// Quick Order Upload
// - Based on quote.js but instead of submitting a contact form,
//   adds matched items to cart and redirects to checkout.
// - Unmatched rows are skipped with a warning.
(function () {
    'use strict';

    // ---------------------------
    // DOM refs
    // ---------------------------
    var rowsEl, addBtn, itemsJsonEl, appEl;

    // Optional CSV UI refs (will be null if not present)
    var csvFileEl, csvUploadBtn, csvDownloadBtn, csvStatusEl;

    // Checkout button + status (two instances: top and bottom)
    var checkoutBtn, cartStatusEl, checkoutBtnTop, cartStatusElTop;

    // ---------------------------
    // State
    // ---------------------------
    var nextId = 1;
    var rows = []; // { id, sku, qty, name, productId, variantId, matchStatus, matchReason, mergedFromCsv }

    // Storefront config
    var shopDomain = '';
    var storefrontToken = '';
    var apiVersion = '2025-10';
    var storefrontEndpoint = '';

    // ---------------------------
    // Helpers
    // ---------------------------
    function syncHiddenJson() {
        if (!itemsJsonEl) return;

        itemsJsonEl.value = JSON.stringify(rows.map(function (r) {
            return {
                sku: (r.sku || '').trim(),
                quantity: Number(r.qty || 1),
                reagent_name: (r.name || '').trim(),
                productId: r.productId || '',
                variantId: r.variantId || '',
                matchStatus: r.matchStatus || 'unmatched',
                matchReason: r.matchReason || '',
                mergedFromCsv: r.mergedFromCsv || 0
            };
        }));
    }

    function createInput(className, placeholder, value, type) {
        var el = document.createElement('input');
        el.className = 'qa-input ' + className;
        el.placeholder = placeholder;
        el.type = type || 'text';
        el.value = value || '';
        return el;
    }

    function debounce(fn, delay) {
        var t;
        return function () {
            var args = arguments;
            clearTimeout(t);
            t = setTimeout(function () { fn.apply(null, args); }, delay || 250);
        };
    }

    function buildStorefrontEndpoint() {
        if (!shopDomain || !apiVersion) return '';
        return 'https://' + shopDomain + '/api/' + apiVersion + '/graphql.json';
    }

    function normalizeSku(s) {
        return (s || '').trim().toLowerCase();
    }

    function findRowBySku(sku) {
        var s = normalizeSku(sku);
        if (!s) return null;
        for (var i = 0; i < rows.length; i++) {
            if (normalizeSku(rows[i].sku) === s) return rows[i];
        }
        return null;
    }

    function isRowEmpty(r) {
        return !(r.sku || '').trim() && !(r.name || '').trim();
    }

    function dedupeResults(items) {
        var seen = {};
        var out = [];

        for (var i = 0; i < items.length; i++) {
            var it = items[i];
            if (!it) continue;

            var key = '';

            if (it.variantId) {
                key = 'variant:' + String(it.variantId);
            } else if (it.productId) {
                key = 'product:' + String(it.productId);
            } else if (it.handle) {
                key = 'handle:' + String(it.handle).toLowerCase();
            } else if (it.sku) {
                key = 'sku:' + String(it.sku).toLowerCase();
            } else if (it.name) {
                key = 'name:' + String(it.name).toLowerCase();
            } else {
                key = 'idx:' + i;
            }

            if (seen[key]) continue;
            seen[key] = true;
            out.push(it);
        }

        return out;
    }

    function sortSkuResults(items, term) {
        var low = (term || '').toLowerCase();

        return items.sort(function (a, b) {
            var aSku = (a.sku || '').toLowerCase();
            var bSku = (b.sku || '').toLowerCase();

            var aExact = aSku === low ? 1 : 0;
            var bExact = bSku === low ? 1 : 0;
            if (aExact !== bExact) return bExact - aExact;

            var aPrefix = aSku.indexOf(low) === 0 ? 1 : 0;
            var bPrefix = bSku.indexOf(low) === 0 ? 1 : 0;
            if (aPrefix !== bPrefix) return bPrefix - aPrefix;

            var aContains = aSku.indexOf(low) !== -1 ? 1 : 0;
            var bContains = bSku.indexOf(low) !== -1 ? 1 : 0;
            if (aContains !== bContains) return bContains - aContains;

            return aSku.localeCompare(bSku);
        });
    }

    // Remove all rows that have neither SKU nor name (cleanup before CSV import)
    function removeAllEmptyRows() {
        // remove from UI
        var emptyIds = rows.filter(isRowEmpty).map(function (r) { return r.id; });
        emptyIds.forEach(function (id) {
            var el = document.querySelector('.qa-row[data-id="' + id + '"]');
            if (el) el.remove();
        });

        // remove from state
        rows = rows.filter(function (r) { return !isRowEmpty(r); });

        syncHiddenJson();
        renderReviewList();
    }

    // ---------------------------
    // Review box UI
    // ---------------------------
    function getOrCreateReviewBox() {
        var el = document.getElementById('qa-review-box');
        if (el) return el;

        el = document.createElement('div');
        el.id = 'qa-review-box';
        el.className = 'qa-review-box';

        // Place under the rows container (or app wrapper)
        if (rowsEl && rowsEl.parentNode) {
            rowsEl.parentNode.appendChild(el);
        } else {
            document.body.appendChild(el);
        }

        return el;
    }

    function renderReviewList() {
        var box = getOrCreateReviewBox();

        var list = rows.filter(function (r) {
            return (r.matchStatus || 'unmatched') === 'unmatched' && (r.matchReason || '').trim().length > 0;
        });

        if (!list.length) {
            box.innerHTML = '';
            return;
        }

        // Build DOM safely to avoid XSS from CSV/user inputs
        var title = document.createElement('div');
        title.className = 'qa-review-title';
        title.textContent = 'Items to review';

        var ul = document.createElement('ul');
        ul.className = 'qa-review-list';

        list.forEach(function (r) {
            var li = document.createElement('li');

            var strong = document.createElement('strong');
            strong.textContent = ((r.sku || '').trim()) || '(no sku)';

            var nameText = document.createTextNode(' — ' + (((r.name || '').trim()) || '(no name)'));
            var qty = Number(r.qty || 1);
            var qtyText = document.createTextNode(' (qty: ' + qty + ')');

            var br = document.createElement('br');
            var reason = document.createElement('span');
            reason.className = 'qa-review-reason';
            reason.textContent = r.matchReason || '';

            li.appendChild(strong);
            li.appendChild(nameText);
            li.appendChild(qtyText);
            li.appendChild(br);
            li.appendChild(reason);

            ul.appendChild(li);
        });

        box.innerHTML = '';
        box.appendChild(title);
        box.appendChild(ul);
    }

    // Update row match status and keep UI + hidden JSON in sync
    function setRowStatus(row, status, reason) {
        row.matchStatus = status;
        row.matchReason = reason || '';

        var rowEl = document.querySelector('.qa-row[data-id="' + row.id + '"]');
        if (rowEl) {
            var badge = rowEl.querySelector('.qa-status');
            if (badge) {
                var isEmpty = !(row.sku || '').trim() && !(row.name || '').trim();
                if (status === 'matched') {
                    badge.textContent = 'Matched';
                    badge.setAttribute('data-status', 'matched');
                    badge.title = '';
                } else {
                    if (isEmpty) {
                        badge.textContent = '';
                        badge.removeAttribute('title');
                        badge.setAttribute('data-status', 'unmatched');
                    } else {
                        badge.textContent = 'Review';
                        badge.setAttribute('data-status', 'unmatched');
                        badge.title = row.matchReason || 'Will be manually reviewed';
                    }
                }
            }

            var qtyEl = rowEl.querySelector('.qa-qty');
            if (qtyEl) {
                if (row.mergedFromCsv && row.mergedFromCsv > 0) {
                    qtyEl.title = 'Merged from CSV: +' + row.mergedFromCsv;
                } else {
                    qtyEl.title = '';
                }
            }
        }

        syncHiddenJson();
        renderReviewList();
    }

    // ---------------------------
    // Storefront Search
    // ---------------------------
    async function storefrontSearch(params) {
        var term = (params && params.term) ? String(params.term) : '';
        var mode = (params && params.mode) ? params.mode : 'sku';

        term = term.trim();
        if (!term) return [];

        if (mode === 'sku') {
            return await searchBySkuPredictive(term);
        }

        return await searchByNameStorefront(term);
    }

    async function searchBySkuPredictive(term) {
        var safe = (term || '').trim();
        if (!safe) return [];

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
            ? window.Shopify.routes.root
            : '/';

        var url =
            root +
            'search/suggest.json?q=' + encodeURIComponent(safe) +
            '&resources[type]=product' +
            '&resources[limit]=10' +
            '&resources[limit_scope]=each' +
            '&resources[options][unavailable_products]=show' +
            '&resources[options][fields]=title';

        try {
            var res = await fetch(url, {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (!res.ok) {
                console.warn('[QO SKU] Predictive search HTTP error', res.status);
                return [];
            }

            var json = await res.json();
            var products = (((json || {}).resources || {}).results || {}).products || [];
            var out = [];
            var low = safe.toLowerCase();

            for (var i = 0; i < products.length; i++) {
                var p = products[i] || {};
                var title = (p.title || '').trim();
                var handle = (p.handle || '').trim();

                if (!title || !handle) continue;

                if (title.toLowerCase().indexOf(low) === -1) continue;

                out.push({
                    productId: p.id ? String(p.id) : '',
                    variantId: '',
                    sku: '',
                    name: title,
                    handle: handle,
                    label: title
                });
            }

            out = dedupeResults(out);

            out.sort(function (a, b) {
                var aName = (a.name || '').toLowerCase();
                var bName = (b.name || '').toLowerCase();

                var aPrefix = aName.indexOf(low) !== -1 ? 1 : 0;
                var bPrefix = bName.indexOf(low) !== -1 ? 1 : 0;
                if (aPrefix !== bPrefix) return bPrefix - aPrefix;

                return aName.localeCompare(bName);
            });

            return out.slice(0, 10);
        } catch (e) {
            console.error('[QO SKU] Predictive search failed', e);
            return [];
        }
    }

    async function searchByNameStorefront(term) {
        if (!storefrontEndpoint || !storefrontToken) return [];

        var safe = term.replace(/"/g, '\\"').trim();
        if (!safe) return [];

        var query =
            'query SearchProducts($q: String!) {' +
            '  products(first: 12, query: $q) {' +
            '    edges {' +
            '      node {' +
            '        id' +
            '        title' +
            '        variants(first: 50) {' +
            '          edges {' +
            '            node {' +
            '              id' +
            '              sku' +
            '              title' +
            '            }' +
            '          }' +
            '        }' +
            '      }' +
            '    }' +
            '  }' +
            '}';

        var q = 'title:*' + safe + '*';

        try {
            var res = await fetch(storefrontEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': storefrontToken
                },
                body: JSON.stringify({
                    query: query,
                    variables: { q: q }
                })
            });

            var json = await res.json();
            if (!res.ok || json.errors) {
                console.warn('[QO NAME] Storefront search error', json.errors || res.status);
                return [];
            }

            var results = [];
            var edges = (json.data && json.data.products && json.data.products.edges)
                ? json.data.products.edges
                : [];

            for (var i = 0; i < edges.length; i++) {
                var p = edges[i].node;
                var vEdges = (p && p.variants && p.variants.edges) ? p.variants.edges : [];

                for (var j = 0; j < vEdges.length; j++) {
                    var variant = vEdges[j].node;
                    if (!variant) continue;

                    results.push({
                        productId: p.id,
                        variantId: variant.id,
                        sku: variant.sku || '',
                        name: p.title || '',
                        label: (p.title || '') + ' — ' + (variant.sku || '')
                    });
                }
            }

            var low = safe.toLowerCase();
            results = results.filter(function (r) {
                return (r.name || '').toLowerCase().indexOf(low) !== -1;
            });

            results = dedupeResults(results);

            return results.slice(0, 10);
        } catch (e) {
            console.error('[QO NAME] Search failed', e);
            return [];
        }
    }

    function getPrefillParams() {
        var p = new URLSearchParams(window.location.search);
        return {
            variantId: (p.get('variant') || '').trim(),
            qty: (p.get('qty') || '1').trim()
        };
    }

    async function storefrontGetVariantByNumericId(variantNumericId) {
        if (!storefrontEndpoint || !storefrontToken) return null;
        if (!variantNumericId) return null;

        var gid = 'gid://shopify/ProductVariant/' + String(variantNumericId);

        var query =
            'query VariantById($id: ID!) {' +
            '  node(id: $id) {' +
            '    ... on ProductVariant {' +
            '      id' +
            '      sku' +
            '      product { id title }' +
            '    }' +
            '  }' +
            '}';

        var res = await fetch(storefrontEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storefrontToken
            },
            body: JSON.stringify({ query: query, variables: { id: gid } })
        });

        var json = await res.json();
        if (!res.ok || json.errors) return null;

        var v = json.data && json.data.node ? json.data.node : null;
        if (!v) return null;

        return {
            productId: v.product.id,
            variantId: v.id,
            sku: v.sku || '',
            name: v.product.title || ''
        };
    }

    async function storefrontGetSingleProductByHandle(handle) {
        if (!storefrontEndpoint || !storefrontToken) return null;
        if (!handle) return null;

        var query =
            'query ProductByHandle($handle: String!) {' +
            '  productByHandle(handle: $handle) {' +
            '    id' +
            '    title' +
            '    variants(first: 1) {' +
            '      edges {' +
            '        node {' +
            '          id' +
            '          sku' +
            '          title' +
            '        }' +
            '      }' +
            '    }' +
            '  }' +
            '}';

        try {
            var res = await fetch(storefrontEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': storefrontToken
                },
                body: JSON.stringify({
                    query: query,
                    variables: { handle: handle }
                })
            });

            var json = await res.json();
            if (!res.ok || json.errors) {
                console.warn('[QO PRODUCT] Product by handle error', json.errors || res.status);
                return null;
            }

            var product = json.data && json.data.productByHandle ? json.data.productByHandle : null;
            if (!product) return null;

            var firstVariant =
                product.variants &&
                product.variants.edges &&
                product.variants.edges[0] &&
                product.variants.edges[0].node
                    ? product.variants.edges[0].node
                    : null;

            return {
                productId: product.id || '',
                variantId: firstVariant ? (firstVariant.id || '') : '',
                sku: firstVariant ? (firstVariant.sku || '') : '',
                name: product.title || '',
                handle: handle
            };
        } catch (e) {
            console.error('[QO PRODUCT] Product by handle failed', e);
            return null;
        }
    }

    async function prefillRowFromUrlIfPresent() {
        var params = getPrefillParams();
        if (!params.variantId) return false;

        var qtyNum = Number(params.qty);
        if (!qtyNum || qtyNum < 1) qtyNum = 1;

        var item = await storefrontGetVariantByNumericId(params.variantId);
        if (!item) {
            addRow({ qty: qtyNum, matchReason: 'Variant not found via Storefront API.' });
            return true;
        }

        addRow({
            sku: item.sku,
            qty: qtyNum,
            name: item.name,
            productId: item.productId,
            variantId: item.variantId
        });

        history.replaceState({}, document.title, window.location.pathname);

        return true;
    }

    async function prefillRowFromQueryIfPresent() {
        var p = new URLSearchParams(window.location.search);
        var query = (p.get('query') || '').trim();

        if (!query) return false;

        var row = addRow({
            sku: query,
            qty: 1,
            name: '',
            productId: '',
            variantId: '',
            matchStatus: 'unmatched',
            matchReason: ''
        });

        await resolveRowBestEffort(row);

        history.replaceState({}, document.title, window.location.pathname);

        return true;
    }

    // ---------------------------
    // Autocomplete Manager (single global dropdown)
    // ---------------------------
    var ac = {
        dropdown: null,
        inputEl: null,
        row: null,
        mode: null,
        items: [],
        active: -1
    };

    function acRemove() {
        if (ac.dropdown) ac.dropdown.remove();
        ac.dropdown = null;
        ac.inputEl = null;
        ac.row = null;
        ac.mode = null;
        ac.items = [];
        ac.active = -1;
    }

    function acEnsure() {
        if (ac.dropdown) return ac.dropdown;
        var el = document.createElement('div');
        el.className = 'qa-ac';
        document.body.appendChild(el);
        ac.dropdown = el;
        return el;
    }

    function acPosition() {
        if (!ac.dropdown || !ac.inputEl) return;
        var r = ac.inputEl.getBoundingClientRect();
        ac.dropdown.style.left = (window.scrollX + r.left) + 'px';
        ac.dropdown.style.top = (window.scrollY + r.bottom) + 'px';
        ac.dropdown.style.width = r.width + 'px';
    }

    function acRender() {
        if (!ac.items.length) return acRemove();

        acEnsure();
        ac.dropdown.innerHTML = '';

        ac.items.forEach(function (it, i) {
            var el = document.createElement('div');
            el.className = 'qa-ac__item' + (i === ac.active ? ' is-active' : '');
            el.textContent = it.label;

           el.addEventListener('mousedown', async function (e) {
                e.preventDefault();
                await applySelection(ac.row, it);
                acRemove();
            });

            ac.dropdown.appendChild(el);
        });

        acPosition();
    }

    var acSearch = debounce(async function () {
        if (!ac.inputEl) return;

        var term = (ac.inputEl.value || '').trim();

        if (ac.mode === 'sku' && term.length < 3) return acRemove();
        if (ac.mode === 'name' && term.length < 2) return acRemove();

        var items = await storefrontSearch({ term: term, mode: ac.mode });
        ac.items = items;
        ac.active = items.length ? 0 : -1;
        acRender();
    }, 250);

    function attachAutocomplete(inputEl, opts) {
        var mode = opts.mode;
        var row = opts.row;

        inputEl.setAttribute('autocomplete', 'off');

        inputEl.addEventListener('input', function () {
            ac.inputEl = inputEl;
            ac.row = row;
            ac.mode = mode;
            acSearch();
        });

        inputEl.addEventListener('focus', function () {
            ac.inputEl = inputEl;
            ac.row = row;
            ac.mode = mode;
        });

        inputEl.addEventListener('keydown', async function (e) {
            if (!ac.dropdown || ac.inputEl !== inputEl) return;

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                ac.active = Math.min(ac.active + 1, ac.items.length - 1);
                acRender();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                ac.active = Math.max(ac.active - 1, 0);
                acRender();
            } else if (e.key === 'Enter') {
                if (ac.items[ac.active]) {
                    e.preventDefault();
                    await applySelection(row, ac.items[ac.active]);
                    acRemove();
                }
            } else if (e.key === 'Escape') {
                e.preventDefault();
                acRemove();
            }
        });

        inputEl.addEventListener('blur', function () {
            setTimeout(function () {
                if (ac.inputEl === inputEl) acRemove();
            }, 120);
        });
    }

    function bindGlobalAutocompleteClose() {
        document.addEventListener('mousedown', function (e) {
            if (!ac.dropdown) return;
            if (ac.inputEl && e.target === ac.inputEl) return;
            if (ac.dropdown.contains(e.target)) return;
            acRemove();
        });

        window.addEventListener('resize', function () {
            if (ac.dropdown) acPosition();
        });

        document.addEventListener('scroll', function () {
            if (ac.dropdown) acPosition();
        }, true);
    }

    // ---------------------------
    // Row selection & resolve
    // ---------------------------
    async function applySelection(row, item) {
        var resolved = item;

        if ((!resolved.variantId || !resolved.sku) && resolved.handle) {
            var fullProduct = await storefrontGetSingleProductByHandle(resolved.handle);
            if (fullProduct) {
                resolved = {
                    productId: fullProduct.productId,
                    variantId: fullProduct.variantId,
                    sku: fullProduct.sku,
                    name: fullProduct.name,
                    handle: fullProduct.handle,
                    label: fullProduct.name
                };
            }
        }

        row.sku = resolved.sku || row.sku || '';
        row.name = resolved.name || row.name || '';
        row.productId = resolved.productId || '';
        row.variantId = resolved.variantId || '';

        var rowEl = document.querySelector('.qa-row[data-id="' + row.id + '"]');
        if (rowEl) {
            var skuEl = rowEl.querySelector('.qa-sku');
            var nameEl = rowEl.querySelector('.qa-name');
            if (skuEl) skuEl.value = row.sku;
            if (nameEl) nameEl.value = row.name;
        }

        if (row.productId) {
            setRowStatus(row, 'matched', '');
        } else {
            setRowStatus(row, 'unmatched', 'Could not resolve product.');
        }
    }

    async function resolveRowBestEffort(row) {
        if (row.productId && row.variantId) {
            setRowStatus(row, 'matched', '');
            return;
        }

        var sku = (row.sku || '').trim();
        var name = (row.name || '').trim();

        if (sku) {
            var skuResults = await storefrontSearch({ term: sku, mode: 'sku' });
            var lowSku = sku.toLowerCase();

            for (var i = 0; i < skuResults.length; i++) {
                if ((skuResults[i].sku || '').toLowerCase() === lowSku) {
                    applySelection(row, skuResults[i]);
                    return;
                }
            }

            if (skuResults.length === 1) {
                applySelection(row, skuResults[0]);
                return;
            }

            if (skuResults.length > 1) {
                var firstSku = ((skuResults[0].sku || '') + '').toLowerCase();
                if (firstSku === lowSku || firstSku.indexOf(lowSku) === 0) {
                    applySelection(row, skuResults[0]);
                    return;
                }
            }
        }

        if (name) {
            var nameResults = await storefrontSearch({ term: name, mode: 'name' });

            if (nameResults.length === 1) {
                applySelection(row, nameResults[0]);
                return;
            }

            if (nameResults.length > 1) {
                setRowStatus(row, 'unmatched', 'Name is ambiguous (multiple matches). Please pick from dropdown.');
                return;
            }
        }

        if (sku || name) {
            setRowStatus(row, 'unmatched', 'Not found in shop (will be skipped at checkout).');
        } else {
            setRowStatus(row, 'unmatched', '');
        }
    }

    // ---------------------------
    // Row UI
    // ---------------------------
    function createRow(row) {
        var wrap = document.createElement('div');
        wrap.className = 'qa-row';
        wrap.setAttribute('data-id', row.id);

        var skuInput = createInput('qa-sku', 'SKU or Name', row.sku || '');
        var qtyInput = createInput('qa-qty', '1', String(row.qty || 1), 'number');
        var nameInput = createInput('qa-name', 'Description', row.name || '');

        qtyInput.min = '1';
        qtyInput.step = '1';

        var statusEl = document.createElement('span');
        statusEl.className = 'qa-status';
        statusEl.textContent = '';
        statusEl.setAttribute('data-status', row.matchStatus || 'unmatched');

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'qa-btn qa-btn--ghost qa-remove';
        removeBtn.textContent = '×';
        removeBtn.setAttribute('aria-label', 'Remove row');

        wrap.appendChild(skuInput);
        wrap.appendChild(qtyInput);
        wrap.appendChild(nameInput);
        wrap.appendChild(statusEl);
        wrap.appendChild(removeBtn);

        skuInput.addEventListener('input', function () {
            row.sku = skuInput.value;
            row.productId = '';
            row.variantId = '';

            if ((row.sku || '').trim() || (row.name || '').trim()) {
                setRowStatus(row, 'unmatched', 'Not matched (will be skipped at checkout).');
            } else {
                setRowStatus(row, 'unmatched', '');
            }
        });

        qtyInput.addEventListener('input', function () {
            var v = parseInt(qtyInput.value, 10);
            if (isNaN(v) || v < 1) v = 1;
            row.qty = v;
            qtyInput.value = String(v);

            syncHiddenJson();
            renderReviewList();
        });

        nameInput.addEventListener('input', function () {
            row.name = nameInput.value;
            row.productId = '';
            row.variantId = '';

            if ((row.sku || '').trim() || (row.name || '').trim()) {
                setRowStatus(row, 'unmatched', 'Not matched (will be skipped at checkout).');
            } else {
                setRowStatus(row, 'unmatched', '');
            }
        });

        attachAutocomplete(skuInput, { mode: 'sku', row: row });
        attachAutocomplete(nameInput, { mode: 'name', row: row });

        removeBtn.addEventListener('click', function () {
            acRemove();

            rows = rows.filter(function (r) { return r.id !== row.id; });

            wrap.remove();

            if (rows.length === 0) addRow();

            syncHiddenJson();
            renderReviewList();
        });

        if (row.matchStatus === 'matched') {
            statusEl.textContent = 'Matched';
            statusEl.setAttribute('data-status', 'matched');
        } else if (row.matchReason) {
            statusEl.textContent = 'Review';
            statusEl.setAttribute('data-status', 'unmatched');
            statusEl.title = row.matchReason;
        }

        if (row.mergedFromCsv && row.mergedFromCsv > 0) {
            qtyInput.title = 'Merged from CSV: +' + row.mergedFromCsv;
        }

        return wrap;
    }

    function addRow(prefill) {
        var row = {
            id: nextId++,
            sku: prefill && prefill.sku ? prefill.sku : '',
            qty: prefill && prefill.qty ? prefill.qty : 1,
            name: prefill && prefill.name ? prefill.name : '',
            productId: prefill && prefill.productId ? prefill.productId : '',
            variantId: prefill && prefill.variantId ? prefill.variantId : '',
            matchStatus: prefill && prefill.matchStatus ? prefill.matchStatus : 'unmatched',
            matchReason: prefill && prefill.matchReason ? prefill.matchReason : '',
            mergedFromCsv: prefill && prefill.mergedFromCsv ? prefill.mergedFromCsv : 0
        };

        rows.push(row);
        rowsEl.appendChild(createRow(row));

        if (row.productId && row.variantId) {
            setRowStatus(row, 'matched', '');
        } else if ((row.sku || '').trim() || (row.name || '').trim()) {
            setRowStatus(row, 'unmatched', row.matchReason || '');
        } else {
            setRowStatus(row, 'unmatched', '');
        }

        return row;
    }

    // ---------------------------
    // CSV
    // ---------------------------
    function parseCsv(text) {
        var lines = (text || '')
            .split(/\r?\n/)
            .map(function (l) { return l.trim(); })
            .filter(function (l) { return l.length > 0; });

        if (!lines.length) return [];

        var headers = lines[0].split(',').map(function (h) { return h.trim().toLowerCase(); });
        var idxSku = headers.indexOf('sku');
        var idxQty = headers.indexOf('quantity');
        var idxName = headers.indexOf('reagent_name');

        var hasHeader = (idxSku !== -1) || (idxQty !== -1) || (idxName !== -1);
        if (!hasHeader) {
            idxSku = 0;
            idxQty = 1;
            idxName = 2;
        }

        var out = [];
        var start = hasHeader ? 1 : 0;

        for (var i = start; i < lines.length; i++) {
            var cols = lines[i].split(',').map(function (c) { return c.trim(); });

            var sku = idxSku >= 0 ? (cols[idxSku] || '') : '';
            var qtyRaw = idxQty >= 0 ? (cols[idxQty] || '') : '';
            var name = idxName >= 0 ? (cols[idxName] || '') : '';

            if (!sku && !name) continue;

            var qty = parseInt(qtyRaw, 10);
            if (isNaN(qty) || qty < 1) qty = 1;

            out.push({
                sku: sku,
                quantity: qty,
                reagent_name: name
            });
        }

        return out;
    }

    function initCsvUi() {
        csvFileEl = document.getElementById('qa-csv-file');
        csvUploadBtn = document.getElementById('qa-upload-csv');
        csvDownloadBtn = document.getElementById('qa-download-template');
        csvStatusEl = document.getElementById('qa-csv-status');

        if (csvDownloadBtn) {
            csvDownloadBtn.addEventListener('click', function () {
                var csv = 'sku,quantity,reagent_name\n';
                var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                var a = document.createElement('a');
                a.href = URL.createObjectURL(blob);
                a.download = 'quick_order_template.csv';
                document.body.appendChild(a);
                a.click();
                a.remove();
            });
        }

        if (csvFileEl) {
            csvFileEl.addEventListener('change', function () {
                if (!csvFileEl.files || !csvFileEl.files[0]) return;

                var file = csvFileEl.files[0];
                var reader = new FileReader();

                reader.onload = async function () {
                    try {
                        removeAllEmptyRows();
                        if (csvStatusEl) csvStatusEl.textContent = 'Importing...';

                        var parsed = parseCsv(String(reader.result || ''));
                        if (!parsed.length) {
                            if (csvStatusEl) csvStatusEl.textContent = 'No valid rows found in CSV.';
                            return;
                        }

                        var toResolve = [];

                        parsed.forEach(function (csvRow) {
                            var sku = (csvRow.sku || '').trim();
                            var qty = Number(csvRow.quantity || 1);
                            var name = (csvRow.reagent_name || '').trim();

                            if (!sku && !name) return;

                            if (sku) {
                                var existing = findRowBySku(sku);
                                if (existing) {
                                    existing.qty = Number(existing.qty || 1) + qty;
                                    existing.mergedFromCsv = Number(existing.mergedFromCsv || 0) + qty;

                                    var existingEl = document.querySelector('.qa-row[data-id="' + existing.id + '"]');
                                    if (existingEl) {
                                        var qtyEl = existingEl.querySelector('.qa-qty');
                                        if (qtyEl) qtyEl.value = String(existing.qty);
                                    }

                                    if (name && !(existing.name || '').trim()) {
                                        existing.name = name;
                                        if (existingEl) {
                                            var nameEl = existingEl.querySelector('.qa-name');
                                            if (nameEl) nameEl.value = name;
                                        }
                                    }

                                    if (existing.productId && existing.variantId) {
                                        setRowStatus(existing, 'matched', '');
                                    } else {
                                        setRowStatus(existing, 'unmatched', existing.matchReason || '');
                                    }

                                    toResolve.push(existing);
                                    return;
                                }
                            }

                            var newRow = addRow({
                                sku: sku,
                                qty: qty,
                                name: name,
                                productId: '',
                                variantId: '',
                                matchStatus: 'unmatched',
                                matchReason: ''
                            });

                            toResolve.push(newRow);
                        });

                        for (var i = 0; i < toResolve.length; i++) {
                            await resolveRowBestEffort(toResolve[i]);
                        }

                        if (csvStatusEl) csvStatusEl.textContent = 'CSV imported. ' + parsed.length + ' rows processed.';
                        if (rowsEl) rowsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    } catch (e) {
                        if (csvStatusEl) csvStatusEl.textContent = 'CSV import failed.';
                    }
                };

                reader.readAsText(file);
                csvFileEl.value = '';
            });
        }

        if (csvUploadBtn) {
            csvUploadBtn.addEventListener('click', function () {
                if (csvFileEl) csvFileEl.click();
            });
        }
    }

    // ---------------------------
    // From cart prefill
    // ---------------------------
    function isFromCart() {
        var p = new URLSearchParams(window.location.search);
        return (p.get('from') || '').toLowerCase() === 'cart';
    }

    async function prefillRowsFromCartIfRequested() {
        if (!isFromCart()) return false;

        var res = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!res.ok) return false;

        var cart = await res.json();
        var items = Array.isArray(cart.items) ? cart.items : [];
        if (!items.length) {
            addRow({ qty: 1, matchReason: 'Cart is empty.' });
            history.replaceState({}, document.title, window.location.pathname);
            return true;
        }

        for (var i = 0; i < items.length; i++) {
            var it = items[i] || {};
            var variantNumericId = it.variant_id ? String(it.variant_id) : '';
            var qtyNum = Number(it.quantity);
            if (!qtyNum || qtyNum < 1) qtyNum = 1;

            if (!variantNumericId) {
                addRow({ qty: qtyNum, matchReason: 'Missing variant id in cart item.' });
                continue;
            }

            var info = await storefrontGetVariantByNumericId(variantNumericId);

            if (!info) {
                addRow({
                    qty: qtyNum,
                    name: it.product_title || '',
                    matchReason: 'Variant not found via Storefront API.'
                });
                continue;
            }

            addRow({
                sku: info.sku,
                qty: qtyNum,
                name: info.name,
                productId: info.productId,
                variantId: info.variantId
            });
        }

        history.replaceState({}, document.title, window.location.pathname);

        return true;
    }

    // ---------------------------
    // Add to Cart & Checkout
    // ---------------------------
    function extractNumericVariantId(gid) {
        // gid://shopify/ProductVariant/12345 → 12345
        if (!gid) return null;
        var s = String(gid);
        var match = s.match(/(\d+)$/);
        return match ? Number(match[1]) : null;
    }

    async function addToCartAndCheckout() {
        // Collect only matched rows with a valid variantId
        var matchedRows = rows.filter(function (r) {
            return r.matchStatus === 'matched' && r.variantId;
        });

        var unmatchedRows = rows.filter(function (r) {
            return (r.matchStatus !== 'matched' || !r.variantId) &&
                   ((r.sku || '').trim() || (r.name || '').trim());
        });

        if (!matchedRows.length) {
            var noMatchMsg = 'No matched products to add. Please resolve your SKUs first.';
            if (cartStatusEl) { cartStatusEl.textContent = noMatchMsg; cartStatusEl.style.color = '#c62828'; }
            if (cartStatusElTop) { cartStatusElTop.textContent = noMatchMsg; cartStatusElTop.style.color = '#c62828'; }
            return;
        }

        // Build items array for /cart/add.js
        var items = matchedRows.map(function (r) {
            return {
                id: extractNumericVariantId(r.variantId),
                quantity: Number(r.qty) || 1
            };
        }).filter(function (item) {
            return item.id && item.quantity > 0;
        });

        if (!items.length) {
            var noVariantMsg = 'Could not resolve variant IDs. Please try again.';
            if (cartStatusEl) { cartStatusEl.textContent = noVariantMsg; cartStatusEl.style.color = '#c62828'; }
            if (cartStatusElTop) { cartStatusElTop.textContent = noVariantMsg; cartStatusElTop.style.color = '#c62828'; }
            return;
        }

        // Show warning about skipped items
        // if (unmatchedRows.length > 0 && cartStatusEl) {
        //     cartStatusEl.textContent = unmatchedRows.length + ' unmatched item(s) will be skipped. Adding ' + items.length + ' product(s) to cart…';
        //     cartStatusEl.style.color = '#e65100';
        // } else if (cartStatusEl) {
        //     cartStatusEl.textContent = 'Adding ' + items.length + ' product(s) to cart…';
        //     cartStatusEl.style.color = '';
        // }

        if (checkoutBtn) checkoutBtn.disabled = true;
        if (checkoutBtnTop) checkoutBtnTop.disabled = true;

        try {
            var res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ items: items })
            });

            if (!res.ok) {
                var err = await res.json().catch(function () { return {}; });
                var errMsg = 'Error: ' + (err.description || err.message || 'Could not add to cart.');
                if (cartStatusEl) { cartStatusEl.textContent = errMsg; cartStatusEl.style.color = '#c62828'; }
                if (cartStatusElTop) { cartStatusElTop.textContent = errMsg; cartStatusElTop.style.color = '#c62828'; }
                if (checkoutBtn) checkoutBtn.disabled = false;
                if (checkoutBtnTop) checkoutBtnTop.disabled = false;
                return;
            }

            // Success → redirect to checkout
            if (cartStatusEl) {
                // cartStatusEl.textContent = items.length + ' product(s) added! Redirecting to checkout…';
                // cartStatusEl.style.color = '#2e7d32';
            }

            window.location.href = '/checkout';
        } catch (e) {
            if (cartStatusEl) { cartStatusEl.textContent = 'Network error. Please try again.'; cartStatusEl.style.color = '#c62828'; }
            if (cartStatusElTop) { cartStatusElTop.textContent = 'Network error. Please try again.'; cartStatusElTop.style.color = '#c62828'; }
            if (checkoutBtn) checkoutBtn.disabled = false;
            if (checkoutBtnTop) checkoutBtnTop.disabled = false;
        }
    }

    // ---------------------------
    // Init
    // ---------------------------
    async function init() {
        rowsEl = document.getElementById('qa-rows');
        addBtn = document.getElementById('qa-add-row');
        itemsJsonEl = document.getElementById('qa-items-json');
        appEl = document.getElementById('quote-app');
        checkoutBtn = document.getElementById('qo-checkout-btn');
        cartStatusEl = document.getElementById('qo-cart-status');
        checkoutBtnTop = document.getElementById('qo-checkout-btn-top');
        cartStatusElTop = document.getElementById('qo-cart-status-top');

        if (!rowsEl || !appEl) return;

        function getMeta(name) {
            var el = document.querySelector('meta[name="' + name + '"]');
            return el ? (el.content || '') : '';
        }

        shopDomain = (window.__SHOP_DOMAIN__ || getMeta('shop-domain') || appEl.getAttribute('data-shop-domain') || window.location.hostname || '').trim();
        storefrontToken = (window.__SF_API_TOKEN__ || getMeta('storefront-api-token') || appEl.getAttribute('data-storefront-token') || '').trim();
        apiVersion = (window.__SF_API_VERSION__ || getMeta('storefront-api-version') || appEl.getAttribute('data-api-version') || '2025-10').trim();
        storefrontEndpoint = buildStorefrontEndpoint();
        bindGlobalAutocompleteClose();
        initCsvUi();

        if (addBtn) {
            addBtn.addEventListener('click', function () {
                addRow();
            });
        }

        if (checkoutBtn) {
            checkoutBtn.addEventListener('click', function () {
                addToCartAndCheckout();
            });
        }

        if (checkoutBtnTop) {
            checkoutBtnTop.addEventListener('click', function () {
                addToCartAndCheckout();
            });
        }

        var didPrefillCart = await prefillRowsFromCartIfRequested();

        var didPrefillUrl = false;

        if (!didPrefillCart) {
            didPrefillUrl = await prefillRowFromUrlIfPresent();
        }

        var didPrefillQuery = false;

        if (!didPrefillCart && !didPrefillUrl) {
            didPrefillQuery = await prefillRowFromQueryIfPresent();
        }

       if (!didPrefillCart && !didPrefillUrl && !didPrefillQuery) {
            addRow();
        }

        syncHiddenJson();
        renderReviewList();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
